import { ParamHistorical } from '../../../../../shared/types/param';

export interface Submotive1HistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Motivo',
    nestedParent: 'Tipo PQR',
};
